function buildSearchBody(opts) {
    // routed trips are now pre-generated and cached
    const {
        cached = true,
        jitted = true,
        routed = true,
        ...otherOpts
    } = opts;

    return _buildSearchBody(otherOpts, { cached, jitted, routed });
}

function _buildSearchBody(opts, typeBody) {
    const {
        batchId,
        destinationGeometry,
        destinationPlaceId,
        destinationAddressComps,
        originPlaceId,
        originGeometry,
        originAddressComps,
        departDatetime,
        distance,
        duration,
        locale,
        currency,
        seoReferrer,
    } = opts;

    return {
        ...typeBody,
        originPlace: {
            geometry: originGeometry,
            address_components: originAddressComps,
            place_id: originPlaceId,
        },
        destPlace: {
            geometry: destinationGeometry,
            address_components: destinationAddressComps,
            place_id: destinationPlaceId,
        },
        batchId,
        departDatetime,
        distance,
        duration,
        locale,
        currency,
        seoRefTransMode: seoReferrer,
    };
}

function serializeSearchParams(opts) {
    if (!opts) {
        return;
    }

    return [
        opts.originPlaceId,
        opts.destinationPlaceId,
        opts.departDatetime,
    ].join('-');
}

function formatTripResults(trips) {
    return trips.reduce((allTrips, trip) => ({
        ...allTrips,
        [trip.trip_id]: trip,
    }), {});
}

export {
    buildSearchBody,
    formatTripResults,
    serializeSearchParams,
};
